module.exports = __webpack_public_path__ + "img/pdf.eba121e7.png";